import { Typography } from "antd";

import * as theme from "./HeadingTask.css";
import { TasksField } from "./types";
const { Title, Text } = Typography;

interface HeadingTaskProps {
    field: TasksField;
}
export function HeadingTask({ field }: HeadingTaskProps) {
    return (
        <div className={theme.fieldLabels}>
            <Title level={4}>{field.title}</Title>
            <Text>{field.instructions}</Text>
        </div>
    );
}
